var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-component',{attrs:{"entityName":"contingent_retrocession","title":"Liste des rétrocessions","buttonGroup":true}})}
var staticRenderFns = []

export { render, staticRenderFns }